// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"5ce19562","358":"5fe60393","437":"0c0b01f0","440":"99c40d91","511":"54821550","634":"e0db7f1e","638":"cea20159","740":"54a8caf6","997":"41e69860"}[chunkId] + ".chunk.js";
};